import styled from '@emotion/styled'

export const ScoutConnectionsWrapper = styled.div`
  max-width: 548px;
`
